import { createContext } from "react";
import { InboxSentimentProviderState } from "./InboxSentimentProvider.types";

export const InboxSentimentProviderContext = createContext<InboxSentimentProviderState | undefined>(undefined);